/**
 * @generated SignedSource<<8f28edf8650271c787c7bb737a143280>>
 * @relayHash d420eaefdfdda2b7e683c937605a479e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d420eaefdfdda2b7e683c937605a479e

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUsersMembershipsInUserListsInput = {
  userListIdsToAddTo: ReadonlyArray<string>;
  userListIdsToRemoveFrom: ReadonlyArray<string>;
  userProfileIds: ReadonlyArray<string>;
};
export type useNetworkArchiveActionsUpdateMembershipsMutation$variables = {
  input: UpdateUsersMembershipsInUserListsInput;
};
export type useNetworkArchiveActionsUpdateMembershipsMutation$data = {
  readonly updateUsersMembershipsInUserLists: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
  };
};
export type useNetworkArchiveActionsUpdateMembershipsMutation = {
  response: useNetworkArchiveActionsUpdateMembershipsMutation$data;
  variables: useNetworkArchiveActionsUpdateMembershipsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNetworkArchiveActionsUpdateMembershipsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUsersMembershipsInUserListsPayload",
        "kind": "LinkedField",
        "name": "updateUsersMembershipsInUserLists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNetworkArchiveActionsUpdateMembershipsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUsersMembershipsInUserListsPayload",
        "kind": "LinkedField",
        "name": "updateUsersMembershipsInUserLists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d420eaefdfdda2b7e683c937605a479e",
    "metadata": {},
    "name": "useNetworkArchiveActionsUpdateMembershipsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "145d19a37e237ada16ead65db8bf906e";

export default node;
